import lib from '@/library'
import config from '@/config'

const state = {
  screenState: 'default',
  screenConfiguration: {},
  screenConfigurationLoaded: false,
  boNavigationHeadlines: []
}

const getters = {
  getScreenState (state) {
    return state.screenState
  },
  getScreenConfiguration (state) {
    return state.screenConfiguration
  },
  getScreenConfigurationLoaded (state) {
    return state.screenConfigurationLoaded
  },
  getBoNavigationHeadlines (state) {
    return state.boNavigationHeadlines
  },
  getAppConfigForBrand (state, allGetters, rootState) {
    return config.app.cdu[rootState.route.params.client] || config.app.cdu['default']
  }
}

const mutations = {
  setScreenState (state, screenState) {
    state.screenState = screenState
  },
  setScreenConfiguration (state, screenConfiguration) {
    state.screenConfiguration = screenConfiguration
  },
  setScreenConfigurationLoaded (state, value) {
    state.screenConfigurationLoaded = value
  },
  setBoNavigationHeadlines (state, boNavigationHeadlines) {
    state.boNavigationHeadlines = boNavigationHeadlines
  }
}

const actions = {
  fetchScreenConfig (context, screenId) {
    return new Promise((resolve) => {
      context.commit('setScreenConfigurationLoaded', false)
      lib.kansas.cduscreenconfiguration({
        screenid: screenId
      }).then(response => {
        if (response.data) {
          var data = response.data
          context.commit('setScreenConfiguration', data)
          // state detection
          lib.cdu.config.determineScreenState()
        } else {
          context.commit('setScreenConfiguration', {})
        }
      }).catch((error) => {
        console.log(error)
        context.commit('setScreenConfiguration', {})
      }).finally(() => {
        context.commit('setScreenConfigurationLoaded', true)
        resolve()
      })
    })
  },
  fetchBoNavigationHeadlines (context) {
    lib.kansas.psheadline().then(response => {
      if (response.data && response.data.headlineitems && response.data.headlineitems.length > 0) {
        context.commit('setBoNavigationHeadlines', response.data.headlineitems)
      } else {
        context.commit('setBoNavigationHeadlines', [])
      }
    }).catch((error) => {
      console.log(error)
      context.commit('setBoNavigationHeadlines', [])
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/cdu.js